import { createStore } from "vuex";
import fakeApi from "@/api/fakeApi";
import api from "@/api/api";

export default createStore({
  state: {
    isLoggedIn: false,
    farms: {},
    farmsTime: {},
    timePeriod: "",
    components: {},
    ispinClicked: false,
    perfClicked: false,
    extClicked: false,
    fatigueClicked: false,
    activeChip: null, // Lens button clicked in the portfolio
    isPlotPressed: false, // Plot button clicked in the WTG's performance
    windfarms: [],
    token: null,
    production: 0
  },

  mutations: {
    login(state, { token, windfarms }) {
      state.isLoggedIn = true;
      state.token = token;
      state.windfarms = windfarms;
      api.setAuthToken(token);
    },

    logout(state) {
      state.isLoggedIn = false;
      state.token = null;
      state.windfarms = [];
      api.setAuthToken(null);
    },

    setPlotPressed(state, value) {
      state.isPlotPressed = value;
    },
    SET_PRODUCTION(state, production) {
      state.production = production;
    },
    SET_FARMS(state, farms) {
      if (!farms) {
        return;
      }

      const defaultIcon = require("@/assets/dot-blue.gif");

      if (Array.isArray(farms)) {
        const previous = Array.isArray(state.farms) ? state.farms : [];
        state.farms = farms.map((farm, index) => ({
          ...farm,
          icon: previous[index]?.icon || farm.icon || defaultIcon,
        }));
        return;
      }

      const previous = !Array.isArray(state.farms) && state.farms ? state.farms : {};
      const updated = {};

      for (const farmName in farms) {
        if (!Object.prototype.hasOwnProperty.call(farms, farmName)) {
          continue;
        }

        const incoming = farms[farmName] || {};
        const existing = previous[farmName] || {};

        updated[farmName] = {
          ...existing,
          ...incoming,
          icon: existing.icon || incoming.icon || defaultIcon,
        };
      }

      state.farms = updated;
    },

    SET_WINDFARM(state, farmId) {
      state.windfarms = [farmId];
    },

    SET_WINDFARMS(state, farmIds) {
      state.windfarms = Array.isArray(farmIds) ? farmIds : [farmIds];
    },
    
    SET_ACTIVE_CHIP(state, value) {
      state.activeChip = value;
    },

    SET_FATIGUE_ICON(state, { farmName, icon }) {
      state.farms[farmName].icon = icon;
    },

    SET_FARMS_TIME(state, farmsTime) {
      state.farmsTime = farmsTime;
    },

    SET_TIME_PERIOD(state, value) {
      state.timePeriod = value;
    },

    SET_COMPONENTS(state, components) {
      state.components = components;
    },

    SET_ISPIN_CLICKED(state, value) {
      state.ispinClicked = value;
    },

    SET_PERF_CLICKED(state, value) {
      state.perfClicked = value;
    },

    SET_EXT_CLICKED(state, value) {
      state.extClicked = value;
    },

    SET_FATIGUE_CLICKED(state, value) {
      state.fatigueClicked = value;
    },
  },


  actions: {
    login({ commit }, { token, windfarms }) {
      commit('login', { token, windfarms });
    },
    logout({ commit }) {
      commit('logout');
    },

    async fetchFarms({ commit, state }) {
      const windfarm = state.windfarms[0];
      await api
        .getWindfarms(windfarm)
        .then((response) => {
          commit("SET_FARMS", response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async fetchFarmsTime({ commit, state }) {
      const windfarm = state.windfarms[0];
      await api
        .getWindfarmsTime(windfarm)
        .then((response) => {
          commit("SET_FARMS_TIME", response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    updateActiveChip({ commit }, value) {
      commit("SET_ACTIVE_CHIP", value);
    },
    
    updateDefaultIcon({ commit, state }) {
      for (let farmName in state.farms) {
        if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName]
        ) {
          const icon = require("@/assets/dot-blue.gif");
          commit("SET_FATIGUE_ICON", { farmName, icon });
        }
      }
    },

    updateFatigueIcon({ commit, state }) {
      for (let farmName in state.farms) {
        if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "24h"
        ) {
          let icon;
          if (state.farms[farmName].fatlens[0] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "1m"
        ) {
          let icon;
          if (state.farms[farmName].fatlens[1] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "3m"
        ) {
          let icon;
          if (state.farms[farmName].fatlens[2] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "6m"
        ) {
          let icon;
          if (state.farms[farmName].fatlens[3] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "12m"
        ) {
          let icon;
          if (state.farms[farmName].fatlens[4] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        }
      }
    },

    updatePerformanceIcon({ commit, state }) {
      for (let farmName in state.farms) {
        if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "24h"
        ) {
          let icon;
          if (state.farms[farmName].perlens[0] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "1m"
        ) {
          let icon;
          if (state.farms[farmName].perlens[1] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "3m"
        ) {
          let icon;
          if (state.farms[farmName].perlens[2] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "6m"
        ) {
          let icon;
          if (state.farms[farmName].perlens[3] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "12m"
        ) {
          let icon;
          if (state.farms[farmName].perlens[4] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else {
            icon = require("@/assets/dot-orange.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        }
      }
    },

    updateExtremeIcon({ commit, state }) {
      for (let farmName in state.farms) {
        if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "24h"
        ) {
          let icon;
          if (state.farms[farmName].extlens[0] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else if (state.farms[farmName].extlens[0] == "yellow") {
            icon = require("@/assets/dot-yellow.gif");
          } else if (state.farms[farmName].extlens[0] == "orange") {
            icon = require("@/assets/dot-orange.gif");
          } else {
            icon = require("@/assets/dot_red_46.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "1m"
        ) {
          let icon;
          if (state.farms[farmName].extlens[1] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else if (state.farms[farmName].extlens[1] == "yellow") {
            icon = require("@/assets/dot-yellow.gif");
          } else if (state.farms[farmName].extlens[1] == "orange") {
            icon = require("@/assets/dot-orange.gif");
          } else {
            icon = require("@/assets/dot_red_46.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "3m"
        ) {
          let icon;
          if (state.farms[farmName].extlens[2] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else if (state.farms[farmName].extlens[2] == "yellow") {
            icon = require("@/assets/dot-yellow.gif");
          } else if (state.farms[farmName].extlens[2] == "orange") {
            icon = require("@/assets/dot-orange.gif");
          } else {
            icon = require("@/assets/dot_red_46.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "6m"
        ) {
          let icon;
          if (state.farms[farmName].extlens[3] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else if (state.farms[farmName].extlens[3] == "yellow") {
            icon = require("@/assets/dot-yellow.gif");
          } else if (state.farms[farmName].extlens[3] == "orange") {
            icon = require("@/assets/dot-orange.gif");
          } else {
            icon = require("@/assets/dot_red_46.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        } else if (
          Object.prototype.hasOwnProperty.call(state.farms, farmName) &&
          state.farms[farmName] &&
          state.timePeriod == "12m"
        ) {
          let icon;
          if (state.farms[farmName].extlens[4] == "green") {
            icon = require("@/assets/dot-green.gif");
          } else if (state.farms[farmName].extlens[4] == "yellow") {
            icon = require("@/assets/dot-yellow.gif");
          } else if (state.farms[farmName].extlens[4] == "orange") {
            icon = require("@/assets/dot-orange.gif");
          } else {
            icon = require("@/assets/dot_red_46.gif");
          }
          commit("SET_FATIGUE_ICON", { farmName, icon });
        }
      }
    },

    toggleIspinClicked({ commit, state }) {
      return new Promise((resolve) => {
        commit("SET_ISPIN_CLICKED", !state.ispinClicked);
        resolve();
      });
    },

    togglePerfClicked({ commit, state }) {
      return new Promise((resolve) => {
        commit("SET_PERF_CLICKED", !state.perfClicked);
        commit("SET_ISPIN_CLICKED", false);
        commit("SET_EXT_CLICKED", false);
        commit("SET_FATIGUE_CLICKED", false);
        resolve();
      });
    },

    toggleExtClicked({ commit, state }) {
      return new Promise((resolve) => {
        commit("SET_EXT_CLICKED", !state.extClicked);
        resolve();
      });
    },

    toggleFatigueClicked({ commit, state }) {
      return new Promise((resolve) => {
        commit("SET_FATIGUE_CLICKED", !state.fatigueClicked);
        resolve();
      });
    },

    async fetchComponents({ commit }, wf) {
      try {
        const response = await fakeApi.getComponents(wf);
        const data = response?.data || {};
        const components = {};

        for (const section in data) {
          if (!Object.prototype.hasOwnProperty.call(data, section)) {
            continue;
          }

          for (const component in data[section]) {
            if (!Object.prototype.hasOwnProperty.call(data[section], component)) {
              continue;
            }

            components[component] = data[section][component];
          }
        }

        commit("SET_COMPONENTS", components);
      } catch (error) {
        console.log(error);
        commit("SET_COMPONENTS", {});
      }
    },
  },


  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    windfarms: state => state.windfarms
  },
});
